<template>
  <WdsTag v-if="column" :variant="statusVariant" sm>
    {{ statusLabel }}
  </WdsTag>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { BidStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const frag = graphql(`
  fragment BidStatusColumn on Bid {
    id
    status
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const statusVariant = computed(() => {
  switch (column.value?.status) {
    case BidStatus.Open:
      return 'info'
    case BidStatus.Accepted:
      return 'success'
    case BidStatus.Rejected:
      return 'error'
    case BidStatus.Cancelled:
      return 'secondary'
    default:
      return 'secondary'
  }
})

const statusLabel = computed(() => {
  switch (column.value?.status) {
    case BidStatus.Open:
      return $t('Open')
    case BidStatus.Accepted:
      return $t('Accepted')
    case BidStatus.Rejected:
      return $t('Rejected')
    case BidStatus.Cancelled:
      return $t('Cancelled')
    default:
      return ''
  }
})
</script>
